"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindNewFocus = void 0;
const react_1 = require("react");
const initialFocusFinder_1 = require("../../core/search/initialFocusFinder");
/**
 * Runs a search for new focus whenever any of the given dependencies change.
 * @param deps The dependency array for when to search for new focus
 */
const useFindNewFocus = (deps) => {
    (0, react_1.useEffect)(() => {
        const rafId = requestAnimationFrame(() => (0, initialFocusFinder_1.findNewFocus)());
        return () => {
            cancelAnimationFrame(rafId);
        };
    }, deps);
};
exports.useFindNewFocus = useFindNewFocus;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRmluZE5ld0ZvY3VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3V0aWxpdHkvdXNlRmluZE5ld0ZvY3VzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsNERBQTREOzs7QUFFNUQsaUNBQWtEO0FBQ2xELDZFQUFvRTtBQUVwRTs7O0dBR0c7QUFDSSxNQUFNLGVBQWUsR0FBRyxDQUFDLElBQW9CLEVBQUUsRUFBRTtJQUNwRCxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsTUFBTSxLQUFLLEdBQUcscUJBQXFCLENBQUMsR0FBRyxFQUFFLENBQUMsSUFBQSxpQ0FBWSxHQUFFLENBQUMsQ0FBQztRQUUxRCxPQUFPLEdBQUcsRUFBRTtZQUNSLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2hDLENBQUMsQ0FBQztJQUNOLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUNiLENBQUMsQ0FBQztBQVJXLFFBQUEsZUFBZSxtQkFRMUIifQ==